import React, { useState } from 'react';
import { Table, Button, Badge } from 'react-bootstrap';

const CaseDetailsTable = ({ caseDetails }) => {
  const [expandedRows, setExpandedRows] = useState({});

  if (!caseDetails) {
    return (
      <div className="text-center p-4">
        <p className="text-muted">Select a case to view its activities</p>
      </div>
    );
  }

  // Toggle row expansion
  const toggleRowExpand = (index) => {
    setExpandedRows(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  // Truncate text for display
  const truncateText = (text, maxLength = 50) => {
    if (!text) return 'N/A';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  const activities = caseDetails.activities || [];

  return (
    <div className="case-details-table">
      {/* Case Summary */}
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="card-title">Case Summary</h5>
          <div className="row">
            <div className="col-md-3">
              <strong>Case ID:</strong> {caseDetails.case_id}
            </div>
            <div className="col-md-3">
              <strong>Customer ID:</strong> {caseDetails.customer_id}
            </div>
            <div className="col-md-3">
              <strong>Messages:</strong> {caseDetails.nr_of_messages || 0}
            </div>
            <div className="col-md-3">
              <strong>Events:</strong> {caseDetails.nr_of_events || 0}
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-6">
              <strong>First Message:</strong>{' '}
              {caseDetails.first_message_ts 
                ? new Date(caseDetails.first_message_ts + 'Z').toLocaleString() 
                : 'N/A'}
            </div>
            <div className="col-md-6">
              <strong>Last Message:</strong>{' '}
              {caseDetails.last_message_ts 
                ? new Date(caseDetails.last_message_ts + 'Z').toLocaleString() 
                : 'N/A'}
            </div>
          </div>
        </div>
      </div>

      {/* Activities Table */}
      <h5>Activities Timeline</h5>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th style={{ width: '50px' }}></th>
            <th>Timestamp</th>
            <th>Activity</th>
            <th>Type</th>
            <th>Direction</th>
            <th>Subject</th>
          </tr>
        </thead>
        <tbody>
          {activities.length === 0 ? (
            <tr>
              <td colSpan={6} className="text-center">
                No activities found for this case
              </td>
            </tr>
          ) : (
            activities.map((activity, index) => {
              const isExpanded = expandedRows[index];
              const isMessageEvent = activity.message_id !== null;
              
              return (
                <React.Fragment key={index}>
                  <tr>
                    <td>
                      {isMessageEvent && (
                        <Button 
                          variant="outline-secondary" 
                          size="sm"
                          onClick={() => toggleRowExpand(index)}
                        >
                          {isExpanded ? '▼' : '▶'}
                        </Button>
                      )}
                    </td>
                    <td>
                      {activity.message_ts 
                        ? new Date(activity.message_ts + 'Z').toLocaleString() 
                        : 'N/A'}
                    </td>
                    <td>{activity.activity || 'N/A'}</td>
                    <td>
                      {isMessageEvent ? (
                        <Badge bg="primary">Message Event</Badge>
                      ) : (
                        <Badge bg="secondary">Native Event</Badge>
                      )}
                    </td>
                    <td>{activity.message_direction || 'N/A'}</td>
                    <td>{truncateText(activity.message_subject)}</td>
                  </tr>
                  {isExpanded && isMessageEvent && (
                    <tr className="expanded-content">
                      <td colSpan={6}>
                        <div className="p-3">
                          <div className="row mb-2">
                            <div className="col-md-6">
                              <strong>Message ID:</strong> {activity.message_id}
                            </div>
                            <div className="col-md-6">
                              <strong>Case ID:</strong> {activity.case_id}
                            </div>
                          </div>
                          
                          <h6 className="mt-3">Subject</h6>
                          <div style={{ 
                            backgroundColor: '#f8f9fa',
                            padding: '10px',
                            borderRadius: '4px',
                            marginBottom: '10px'
                          }}>
                            {activity.message_subject || 'No subject'}
                          </div>

                          <h6>Message Body</h6>
                          <pre style={{ 
                            whiteSpace: 'pre-wrap', 
                            maxHeight: '300px', 
                            overflow: 'auto',
                            backgroundColor: '#f8f9fa',
                            padding: '10px',
                            borderRadius: '4px'
                          }}>
                            {activity.message_body || 'No message body'}
                          </pre>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default CaseDetailsTable;